import CitySEOHead from "@/components/feature/CitySEOHead";
import ClearwaterHeroSection from "./components/HeroSection";
import ClearwaterStickyNav from "./components/StickyNav";
import ClearwaterProcessingTimeSection from "./components/ProcessingTimeSection";
import ClearwaterServicesSection from "./components/ServicesSection";
import ClearwaterLocalAreaSection from "./components/LocalAreaSection";
import ClearwaterTravelTimingSection from "./components/TravelTimingSection";
import ClearwaterDestinationsSection from "./components/DestinationsSection";
import ClearwaterTestimonialsSection from "./components/TestimonialsSection";
import ClearwaterAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ClearwaterComparisonSection from "./components/ComparisonSection";
import ClearwaterMistakesSection from "./components/MistakesSection";
import ClearwaterHowItWorksSection from "./components/HowItWorksSection";
import ClearwaterFAQSection, { faqs as clearwaterFaqsRaw } from "./components/FAQSection";
import ClearwaterHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import ClearwaterFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const clearwaterServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

const clearwaterFaqs = clearwaterFaqsRaw.map((f: { question: string; answer: string }) => ({ q: f.question, a: f.answer }));

export default function ClearwaterPage() {
  return (
    <>
      <CitySEOHead
        city="Clearwater"
        state="Florida"
        stateAbbr="FL"
        route="/cities/clearwater"
        title="Emergency Passport Clearwater, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Clearwater, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Pinellas County travelers, Tampa Bay cruise passengers, and spring break families."
        geoPlacename="Clearwater, Florida"
        geoPosition="27.9659;-82.8001"
        faqs={clearwaterFaqs}
        servicesSchema={clearwaterServices}
        statePageName="Florida"
        statePageRoute="/states/florida"
      />
      <div className="min-h-screen bg-white">
        <ClearwaterHeroSection />
        <ClearwaterStickyNav />
        <ClearwaterProcessingTimeSection />
        <ClearwaterServicesSection />
        <ClearwaterLocalAreaSection />
        <ClearwaterTravelTimingSection />
        <ClearwaterDestinationsSection />
        <ClearwaterTestimonialsSection />
        <ClearwaterAcceptanceFacilitiesSection />
        <ClearwaterComparisonSection />
        <ClearwaterMistakesSection />
        <ClearwaterHowItWorksSection />
        <ClearwaterFAQSection />
        <ClearwaterHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/clearwater" state="FL" />
        <ClearwaterFinalCTA />
      </div>
    </>
  );
}